<div *ngIf="isActive" class="check-status-tooltip">
  <div class="perct-block">
    <div class="small-block-color {{ tooltipObject.color }}"></div>
    <div class="block-text">{{ tooltipObject.value }}</div>
  </div>
  <div class="tip-body-text">
    {{ tooltipObject.text }}
  </div>
</div>
